module.exports = __webpack_public_path__ + "static/media/news3.02819f32.png";